import { Actions } from './not-delivered-reason.actions'
import { fromJS } from 'immutable'
import * as NotDeliveredReasonTypes from './not-delivered-reason.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page_size: 20,
      page: 1,
    },
    total: 0,
    results: 0,
  },
  create: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  update: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
})

export function notDeliveredReasonReducer(
  state = initialState,
  action: Actions,
) {
  switch (action.type) {
    case NotDeliveredReasonTypes.UPDATE_NOT_DELIVERED_REASON_REQUEST: {
      return state.setIn(['update', 'isLoading'], true)
    }

    case NotDeliveredReasonTypes.UPDATE_NOT_DELIVERED_REASON_SUCCESS: {
      return state.setIn(['update', 'isLoading'], false)
    }

    case NotDeliveredReasonTypes.UPDATE_NOT_DELIVERED_REASON_FAILURE: {
      return state.setIn(['update', 'isLoading'], false)
    }

    case NotDeliveredReasonTypes.CREATE_NOT_DELIVERED_REASON_REQUEST: {
      return state.setIn(['create', 'isLoading'], true)
    }

    case NotDeliveredReasonTypes.CREATE_NOT_DELIVERED_REASON_SUCCESS: {
      return state.setIn(['create', 'isLoading'], false)
    }

    case NotDeliveredReasonTypes.CREATE_NOT_DELIVERED_REASON_FAILURE: {
      return state.setIn(['create', 'isLoading'], false)
    }

    case NotDeliveredReasonTypes.DELETE_NOT_DELIVERED_REASON_REQUEST: {
      return state
    }

    case NotDeliveredReasonTypes.DELETE_NOT_DELIVERED_REASON_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case NotDeliveredReasonTypes.DELETE_NOT_DELIVERED_REASON_FAILURE: {
      return state
    }

    case NotDeliveredReasonTypes.FETCH_NOT_DELIVERED_REASON_LIST_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case NotDeliveredReasonTypes.FETCH_NOT_DELIVERED_REASON_LIST_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'results'], fromJS(action.results))
    }

    case NotDeliveredReasonTypes.FETCH_NOT_DELIVERED_REASON_LIST_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case NotDeliveredReasonTypes.FETCH_NOT_DELIVERED_REASON_REQUEST: {
      return state.setIn(['update', 'isLoading'], true)
    }

    case NotDeliveredReasonTypes.FETCH_NOT_DELIVERED_REASON_SUCCESS: {
      return state
        .setIn(['update', 'isLoading'], false)
        .setIn(['update', 'data'], fromJS(action.payload).delete('id'))
    }

    case NotDeliveredReasonTypes.FETCH_NOT_DELIVERED_REASON_FAILURE: {
      return state.setIn(['update', 'isLoading'], false)
    }

    case NotDeliveredReasonTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case NotDeliveredReasonTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
